<template>
	<div class="page-phone-verification">
		<div class="container">
			<div v-if="showCard" class="phone-verification">
				<div class="phone-verification-card">
					<div class="app-logo-wrapper">
						<img :src="appLogo" :alt="appName" />
					</div>

					<div class="h5 text-center font-weight-bold mb-4">Verify Phone Number</div>

					<form class="phone-verification-form" @submit.prevent="verifyOTP()">
						<div class="form-group">
							<label>Phone Number</label>
							<div class="input-group">
								<div class="input-group-prepend">
									<span class="input-group-text" id="basic-addon1">+62</span>
								</div>
								<input
									class="form-control"
									type="text"
									name="phone"
									placeholder="Phone / WA Number"
									minlength="9"
									v-model.trim="otpPayload.phone"
									:disabled="otpStatusData.otp_send_count >= 1"
									@input="phoneValidation"
								/>
							</div>
							<small v-if="errorMessages.phone" class="text-danger">
								{{ errorMessages.phone }}
							</small>
						</div>

						<div class="form-group">
							<label>OTP</label>
							<div class="input-group">
								<input
									class="form-control"
									type="text"
									maxlength="6"
									name="otp"
									placeholder="OTP Code"
									@input="validateInputOtp"
									v-model.trim="otpPayload.otp"
								/>
								<div class="input-group-append">
									<button
										class="btn btn-outline-secondary button-append-custom"
										:class="{ 'is-loading': isGeneratingOtp }"
										type="button"
										:disabled="sendOtpButtonDisabled"
										@click="generateOTP"
									>
										{{ formattedTimeLeft }}
									</button>
								</div>
							</div>
							<!-- <small v-if="errorMessages.name" class="text-danger">{{
								errorMessages.name
							}}</small> -->
						</div>

						<div
							v-if="otpStatusData.otp_send_count >= 3 && otpTimeInfo.isExpired"
							class="request-admin-text"
						>
							<span style="margin-inline: auto"
								>Didn't get the code?
								<a href="" @click="sendCodeWA">Request to admin</a></span
							>
						</div>

						<div class="form-group text">
							<button
								type="submit"
								class="btn btn-submit w-100 btn-primary"
								:class="{ 'is-loading': isVerifyingOtp }"
								:disabled="verifyButtonDisabled"
							>
								{{ $t('verify') }}
							</button>
						</div>
					</form>
				</div>
			</div>

			<div v-else class="loader-wrapper">
				<div class="text-center">
					<img :src="appLogo" width="200px" class="d-block m-auto" :alt="appName" />
					<div
						class="spinner-border my-4"
						style="width: 3rem; height: 3rem"
						role="status"
					>
						<span class="sr-only">Loading...</span>
					</div>
					<div>
						Sedang memuat...
						<br />
						Mohon untuk tidak menutup halaman ini!
					</div>
				</div>
			</div>
		</div>

		<notifications group="phone-verification" position="bottom right" />
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import relativeTime from 'dayjs/plugin/relativeTime';

import phoneVerificationApi from '@/api/phone-verification';

dayjs.extend(utc);
dayjs.extend(relativeTime);

export default {
	name: 'phone-verification',
	data() {
		return {
			showCard: false,
			otpPayload: {
				userId: '',
				phone: '',
				otp: '',
			},
			otpStatusData: {
				is_phone_verified: false,
				otp_last_expired_at: '',
				otp_last_generated_at: '',
				otp_send_count: 0,
				system_otp_phone_number: '',
				verification_uuid: '',
			},
			otpTimeInfo: {
				isExpired: false,
				countdownInterval: null,
				timeLeftInSeconds: 0,
			},
			isGeneratingOtp: false,
			isVerifyingOtp: false,
			errorMessages: {
				phone: '',
			},
		};
	},
	sockets: {
		phone_verification_add(newUserData) {
			this.setUser(newUserData);
			this.isVerifyingOtp = false;
			this.$notify({
				group: 'app',
				type: 'success',
				title: 'Phone Verification',
				text: 'Phone number is verified',
			});

			this.checkPhoneVerified();
		},
	},
	computed: {
		...mapGetters({
			appName: 'appName',
			appLogo: 'appLogo',
			user: 'user',
		}),
		formattedTimeLeft() {
			if (this.otpTimeInfo.isExpired) {
				return this.otpStatusData.otp_send_count === 0 ? 'Send OTP' : 'Resend OTP';
			}
			const minutes = Math.floor(this.otpTimeInfo.timeLeftInSeconds / 60);
			const seconds = Math.floor(this.otpTimeInfo.timeLeftInSeconds % 60);
			return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
		},
		sendOtpButtonDisabled() {
			return (
				!this.otpTimeInfo.isExpired
				|| this.isGeneratingOtp
				|| this.otpStatusData.otp_send_count >= 3
				|| this.errorMessages.phone !== ''
			);
		},
		verifyButtonDisabled() {
			return (
				(this.otpStatusData.otp_send_count === 0
					|| this.otpStatusData.otp_send_count >= 3)
				&& this.otpTimeInfo.isExpired
			);
		},
	},
	methods: {
		...mapActions({
			logout: 'logout',
			setUser: 'setUser',
		}),
		checkPhoneVerified() {
			if (!this.user.is_phone_verified) return;
			this.$router.push({ path: '/' });
		},
		checkPhoneNumber() {
			this.checkPhoneVerified();

			const paramsId = this.$route.params.id || false;
			if (paramsId) {
				// check if id not match with auth id force logout
				if (paramsId !== this.user._id) {
					this.logout();
					return;
				}

				this.otpPayload.userId = paramsId;
			} else {
				this.otpPayload.userId = this.user._id;
			}
			this.checkVerificationStatus();
		},
		checkVerificationStatus() {
			const callback = (response) => {
				this.otpStatusData = response.data;
				this.otpPayload.phone =
					response.data.otp_send_count >= 1 ? response.data.temp_phone : this.user.phone;
				this.showCard = true;
				this.startCountdown();
				this.isGeneratingOtp = false;
			};

			const errorCallback = (error) => {
				this.$notify({
					group: 'phone-verification',
					type: 'error',
					title: 'Phone Verification',
					text: error.response.data.message,
				});
				this.isGeneratingOtp = false;
			};

			phoneVerificationApi.check(callback, errorCallback);
		},
		updateTimeLeft() {
			const now = dayjs();
			const otpLastExpiredAt = dayjs.utc(this.otpStatusData.otp_last_expired_at);

			if (now.isAfter(otpLastExpiredAt) || this.otpStatusData.otp_last_expired_at === null) {
				this.otpTimeInfo.isExpired = true;
				clearInterval(this.otpTimeInfo.countdownInterval);
			} else {
				this.otpTimeInfo.isExpired = false;
				const diffInSeconds = otpLastExpiredAt.diff(now, 'second');
				this.otpTimeInfo.timeLeftInSeconds = Math.max(diffInSeconds, 0);
			}
		},
		startCountdown() {
			this.updateTimeLeft();

			this.otpTimeInfo.countdownInterval = setInterval(() => {
				this.updateTimeLeft();
			}, 1000);
		},
		generateOTP() {
			this.isGeneratingOtp = true;

			const params = {
				phone: this.otpPayload.phone,
			};

			const callback = () => {
				this.checkVerificationStatus();
			};

			const errorCallback = (error) => {
				this.$notify({
					group: 'phone-verification',
					type: 'error',
					title: 'Phone Verification',
					text: error.response.data.message,
				});
				this.isGeneratingOtp = false;
			};

			phoneVerificationApi.generate(params, callback, errorCallback);
		},
		verifyOTP() {
			this.isVerifyingOtp = true;

			const params = {
				otp: this.otpPayload.otp,
			};

			const callback = (response) => {
				this.setUser(response.data);
				this.isVerifyingOtp = false;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Phone Verification',
					text: 'Phone number is verified',
				});

				this.checkPhoneVerified();
			};

			const errorCallback = (error) => {
				this.isVerifyingOtp = false;
				this.$notify({
					group: 'phone-verification',
					type: 'error',
					title: 'Phone Verification',
					text: error.response.data.message,
				});
			};

			phoneVerificationApi.verify(params, callback, errorCallback);
		},
		sendCodeWA(event) {
			event.preventDefault();
			window.open(
				`https://api.whatsapp.com/send/?phone=${this.otpStatusData.system_otp_phone_number}&text=OSTOCK%23${this.otpStatusData.verification_uuid}%23%0AJangan+ubah+pesan+ini.+Kirim+untuk+melanjutkan+dan+kembali+ke+aplikasi+OSTOCK.`,
				'blank',
			);
		},
		isPhoneError() {
			return (
				this.otpPayload.phone.trim() !== ''
				&& !new RegExp(/^\+\d+$/).test(this.otpPayload.phone.trim())
			);
		},
		phoneValidation() {
			const validPhone = this.isPhoneError();
			this.otpPayload.phone = this.otpPayload.phone.replace(/[^\d]/g, '');
			if (validPhone) {
				const firstSelection = this.otpPayload.phone.substring(0, 1);
				const secondSelection = this.otpPayload.phone.substring(0, 2);
				let phone = this.otpPayload.phone;
				if (secondSelection === '62') {
					phone = phone.replace('62', '');
				} else if (firstSelection === '0') {
					phone = phone.replace('0', '');
				}
				this.otpPayload.phone = phone;
				if (this.otpPayload.phone.length < 9) {
					this.errorMessages.phone = 'Phone number at least 9 digits';
				} else {
					this.errorMessages.phone = '';
				}
			} else {
				this.errorMessages.phone = 'Invalid phone number';
			}
		},
		validateInputOtp() {
			this.otpPayload.otp = this.otpPayload.otp.replace(/\D/g, '');
			if (this.otpPayload.otp.length > 6) {
				this.otpPayload.otp = this.otpPayload.otp.slice(0, 6);
			}
		},
	},
	mounted() {
		this.checkPhoneNumber();
	},
	beforeDestroy() {
		clearInterval(this.otpTimeInfo.countdownInterval);
	},
};
</script>

<style lang="scss" scoped>
.phone-verification {
	width: 100%;
	height: auto;
	padding-top: 4em;
	display: flex;
	flex-direction: row;
	justify-content: center;
}

.phone-verification-card {
	width: 100%;
	height: auto;
	max-width: 600px;
	margin: 2em auto;
	padding: 1em;
	background-color: #ffffff;
	border-radius: 16px;
	box-shadow: 0 1px 10px -4px #9c9c9c;
	transition: 0.2s all ease-in-out;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 1em;

	@media (max-width: 575px) {
		margin-top: 0;
		box-shadow: none;
	}
}

.app-logo-wrapper {
	margin: 2em 1em;
	width: 100%;
	max-width: 210px;
}

.phone-verification-form {
	width: 100%;
	height: auto;
	box-sizing: border-box;
	padding-inline: 1em;
}

.btn-submit {
	margin-top: 0.5em;
	padding-top: 0.5em;
	padding-bottom: 0.5em;
	font-weight: 600;
	text-transform: uppercase;
}

.button-append-custom {
	min-width: 114px;
}

.request-admin-text {
	width: 100%;
	text-align: center;
}

.loader-wrapper {
	width: 100%;
	height: 70vh;
	display: flex;
	flex-direction: row;
	justify-content: center;
  align-items: center;
}
</style>
